/* eslint-disable react/no-unused-prop-types,no-console,
react/no-danger,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import ContentLoader from 'react-content-loader';
import { formatRoute } from 'react-router-named-routes';
import { withTranslation } from 'react-i18next';
// material-ui icons
import Done from '@material-ui/icons/Done';
import Edit from '@material-ui/icons/Edit';
import Updated from '@material-ui/icons/EditOutlined';
import ArrowForward from '@material-ui/icons/ArrowForward';
import LinearProgress from '@material-ui/core/LinearProgress';
import Refresh from '@material-ui/icons/Refresh';
import Map from '@material-ui/icons/PinDropOutlined';
import Search from '@material-ui/icons/Search';
// material-ui/ core components
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// global variables
import { adStatus } from 'config';
// our components
import { EXPIRED_AD, USER } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import { LoadingAnimation } from 'components/common/Loading';
import Paginator from 'components/common/Paginator';
import { TableLoader } from 'components/common/TableLoader';
import WithPermission from 'components/User/WithPermission';
import Badge from 'components/UI/Badge/Badge';
import matchedRules, { isFromList } from 'helpers/matchedRulesHelper';
import InputAdornment from '@material-ui/core/InputAdornment';
import CustomInput from 'components/UI/CustomInput/CustomInput';
import dateFormat from 'helpers/dateHelper';

/**
 * @description - ExpiredAdList component
 * @augments React.Component
 */
class ExpiredAdList extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      search: props.adId,
    };
  }

  /**
   * @description
   * Call onRefresh callback.
   */
  handleRefresh = () => {
    const { onRefresh } = this.props;
    onRefresh();
  };

  /**
   * @description
   * Redirect to user/read route.
   *
   * @param {number} id - Id of the user to read.
   */
  handleReadUser = id => {
    const history = this.context;
    history.push(formatRoute(USER.DETAILS, { id }));
  };

  /**
   * @description
   * Render Status cell.
   *
   * @param {Object} node - An ad.
   * @returns {*} Status cell.
   */
  renderCellStatus = node => {
    const { classes, t } = this.props;
    let status;
    switch (node.lastStatus) {
      case adStatus.PENDING_VERIFICATION:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.pendingTag}`}>
            {t('ad.list.ad_status.pending_verification')}
          </h6>
        );
        break;
      case adStatus.PENDING_PROCESSING:
        status = (
          <h6
            id={`ad-pending-processing-${node.id}`}
            className={`${classes.cellStatus} ${classes.pendingTag}`}
          >
            {t('ad.list.ad_status.pending_processing')}
          </h6>
        );
        break;
      case adStatus.PROCESSING:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.pendingTag}`}>
            {t('ad.list.ad_status.processing')}
          </h6>
        );
        break;
      case adStatus.TO_REVIEW:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.pendingTag}`}>
            {t('ad.list.ad_status.to_review')}
          </h6>
        );
        break;
      case adStatus.UNPUBLISHED_BY_MODERATOR:
        status = (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.unpublished_by_moderator')}
          </h6>
        );
        break;
      case adStatus.UNPUBLISHED_BY_PROCESSOR:
        status = (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.unpublished_by_processor')}
          </h6>
        );
        break;
      case adStatus.PUBLISHED_BY_PROCESSOR:
        status = (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.published_by_processor')}
          </h6>
        );
        break;
      case adStatus.PUBLISHED_BY_MODERATOR:
        status = (
          <h6 className={`${classes.cellStatus}`}>
            {t('ad.list.ad_status.published_by_moderator')}
          </h6>
        );
        break;
      case adStatus.UNPUBLISHED_BY_USER:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.deletedTag}`}>
            {t('ad.list.ad_status.unpublished_by_user')}
          </h6>
        );
        break;
      case adStatus.UNPUBLISHED_BY_USER_DELETED:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.deletedTag}`}>
            {t('ad.list.ad_status.unpublished_by_user_deleted')}
          </h6>
        );
        break;
      case adStatus.UNPUBLISHED_BY_USER_BLOCKED:
        status = (
          <h6 className={`${classes.cellStatus} ${classes.deletedTag}`}>
            {t('ad.list.ad_status.unpublished_by_user_blocked')}
          </h6>
        );
        break;
      default:
        status = '';
        break;
    }
    return (
      <React.Fragment>
        <div className={classes.infoStatusAndReview}>{status}</div>
        {node.reviewed && (
          <div className={classes.reviewCheck}>
            <span>
              <Done />
              <WithPermission
                alt={<span>{node.reviewedBy && node.reviewedBy.fullname}</span>}
                allowPermissions={['view_user']}
              >
                <Button
                  data-cy="adReviewedByBtn"
                  id={`ads-reviewed-${node.id}`}
                  className={classes.adBtns}
                  simple
                  size="sm"
                  color="primary"
                  onClick={() => this.handleReadUser(node.reviewedBy.id)}
                >
                  {node.reviewedBy && node.reviewedBy.fullname}
                </Button>
              </WithPermission>
            </span>
            <span className={classes.dateFormat}>
              {dateFormat(node.reviewedOn, t)}
            </span>
          </div>
        )}
      </React.Fragment>
    );
  };

  /**
   * @description
   * Description of ReactTable columns.
   *
   * @returns {Array} Table columns.
   */
  renderColumns = () => {
    const { classes, t } = this.props;
    return [
      {
        Header: (
          <span className={classes.headerField} style={{ marginLeft: '15px' }}>
            {t('ad.list.headers.title')}
          </span>
        ),
        accessor: 'title',
        sortable: false,
        filterable: false,
        minWidth: 300,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('ad.list.headers.user')}
          </span>
        ),
        accessor: 'user',
        sortable: false,
        filterable: false,
        maxWidth: 220,
      },
      {
        Header: (
          <div className={classes.headerField}>
            {t('ad.list.headers.ipScore')}
          </div>
        ),
        accessor: 'ipScore',
        sortable: false,
        filterable: false,
        minWidth: 150,
      },
      {
        Header: (
          <span className={classes.headerField}>
            {t('review_queue.headers.rules')}
          </span>
        ),
        accessor: 'rules',
        sortable: false,
        filterable: false,
        minWidth: 120,
      },
      {
        Header: (
          <div className={classes.headerField} style={{ textAlign: 'center' }}>
            {t('expired_ad.list.headers.last_status')}
          </div>
        ),
        accessor: 'lastStatus',
        sortable: false,
        filterable: false,
        maxWidth: 120,
      },
      {
        expander: true,
        show: false,
      },
    ];
  };

  /**
   * @description
   * Map the data from api to ReactTable rows.
   *
   * @param {Array} edges - All ads from api.
   * @returns {Array} Table rows.
   */
  renderRows = edges => {
    const { classes, t } = this.props;
    const history = this.context;

    return edges.map(({ node }) => ({
      title: (
        <div style={{ marginLeft: '15px' }}>
          <WithPermission
            alt={
              <div
                id={`ad-title-${node.id}`}
                data-cy="adTitle"
                className={classes.adTitleContainer}
              >
                <div className={classes.idAndDate}>
                  <WithPermission
                    allowPermissions={[
                      'view_autopaidad',
                      'view_ownership_autopaidad',
                    ]}
                  >
                    {node.isAuto && (
                      <span className={classes.adAuto}>AUTO</span>
                    )}
                  </WithPermission>
                  <p>
                    <b data-cy={node.id}>ID: {node.id}</b>
                    {node.flagCount > 0 && (
                      <span style={{ marginLeft: 8 }}>
                        <Badge color="danger">{node.flagCount}</Badge>
                      </span>
                    )}
                  </p>
                  <p className={classes.modificationDate}>
                    <Updated />
                    {node.updatedOn && dateFormat(node.updatedOn, t)}
                  </p>
                </div>
                <p className={classes.adTitle}>{node.title}</p>
                <p
                  className={classes.modificationDate}
                  style={{ color: '#5f625f', fontWeight: 500 }}
                >
                  <Map />
                  {node.municipality && `${node.municipality.name}, `}
                  {node.province.name}
                </p>
              </div>
            }
            allowPermissions={['view_expiredad']}
          >
            <div
              style={{ padding: '8px 0' }}
              id={`ad-title-${node.id}`}
              data-cy="adTitle"
            >
              <div className={classes.idAndDate}>
                <WithPermission
                  allowPermissions={[
                    'view_autopaidad',
                    'view_ownership_autopaidad',
                  ]}
                >
                  {node.isAuto && <span className={classes.adAuto}>AUTO</span>}
                </WithPermission>
                <p style={{ marginRight: 8 }}>
                  <b data-cy={node.id}>ID: {node.id}</b>
                  {node.flagCount > 0 && (
                    <span style={{ marginLeft: 8 }}>
                      <Badge color="danger">{node.flagCount}</Badge>
                    </span>
                  )}
                </p>
                <p className={classes.modificationDate}>
                  <Updated /> {node.updateCount} •
                  <span style={{ marginLeft: 4 }}>
                    {node.updatedOn && dateFormat(node.updatedOn, t)}
                  </span>
                </p>
              </div>
              <ul
                key={`ad-subcategory-${node.id}`}
                className={classes.adCatBread}
              >
                <li data-cy="adCategory">
                  {node.subcategory.parentCategory.title}
                </li>
                <li className={classes.adIconBread}>
                  <ArrowForward color="disabled" />
                </li>
                <li data-cy="adSubcategory">{node.subcategory.title}</li>
              </ul>
              <a
                className={['read', classes.adBtns, classes.titleBtn].join(' ')}
                href={formatRoute(EXPIRED_AD.DETAILS, { id: node.id })}
                onClick={e => {
                  e.preventDefault();
                  history.push(
                    formatRoute(EXPIRED_AD.DETAILS, { id: node.id }),
                  );
                }}
              >
                {node.title}
              </a>
              <p
                className={classes.modificationDate}
                style={{ color: '#5f625f', fontWeight: 500 }}
              >
                <Map />
                {node.municipality && `${node.municipality.name}, `}
                {node.province.name}
              </p>
            </div>
          </WithPermission>
        </div>
      ),
      ipScore: (
        <React.Fragment>
          <div className={[classes.botScore, classes.idAndDate].join(' ')}>
            <span style={{ marginLeft: '8px' }}>
              {node.botScoreInsert !== null
                ? node.botScoreInsert
                : t('common.unknown')}
            </span>
            <span style={{ marginLeft: '8px' }}>
              {node.countryInsert || t('common.unknown')}
            </span>
            <span style={{ marginLeft: '8px' }}>
              {node.ipInsert || t('common.unknown')}
            </span>
          </div>
          {node.updateCount > 0 && (
            <React.Fragment>
              <div className={[classes.botScore, classes.idAndDate].join(' ')}>
                <Edit />
                <a
                  className={['read', classes.adBtns, classes.scoreLink].join(
                    ' ',
                  )}
                  href={`${EXPIRED_AD.LIST}?sameOwnerAds=${node.id}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ float: 'left' }}
                >
                  {node.botScoreUpdate !== null
                    ? node.botScoreUpdate
                    : t('common.unknown')}
                </a>
                <span>{node.countryUpdate || t('common.unknown')}</span>
                {node.ipUpdate !== null ? (
                  <span style={{ marginLeft: '8px' }}>{node.ipUpdate}</span>
                ) : (
                  <span style={{ marginLeft: '8px' }}>
                    {t('common.unknown')}
                  </span>
                )}
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      ),
      user: (
        <div data-cy="adUserInfo" className={classes.adUserContainer}>
          {node.user ? (
            <WithPermission
              alt={<span>{node.user.fullname}</span>}
              allowPermissions={['view_user']}
            >
              <Button
                simple
                color="primary"
                className={['read', classes.adBtns, classes.titleBtn].join(' ')}
                onClick={() => this.handleReadUser(node.user.id)}
              >
                {node.user.fullname}
              </Button>
            </WithPermission>
          ) : (
            <p>
              <b>{node.name}</b>
            </p>
          )}
          <p>
            <b> {node.user ? node.user.email : node.email} </b>
          </p>
          <p data-cy="adUserPhone" key={`user-phone-${node.id}`}>
            {node.user ? node.user.phone : node.phone}
          </p>
        </div>
      ),
      rules: (
        <React.Fragment>
          {node.matchedRules &&
            Array.isArray(node.matchedRules) &&
            node.matchedRules.map((matchedRule, key) => {
              if (!isFromList(matchedRule)) {
                return matchedRules(node, classes, t, matchedRule);
              }
              return (
                <div
                  key={`mr-list-${node.id}-${key}`}
                  className={classes.matchedRule}
                  dangerouslySetInnerHTML={{
                    __html: matchedRules(node, classes, t, matchedRule),
                  }}
                />
              );
            })}
        </React.Fragment>
      ),
      lastStatus: <div data-cy="lastStatus">{this.renderCellStatus(node)}</div>,
    }));
  };

  /**
   * @description
   * Render Filter, Paginator and ReactTable components.
   * @returns {*} Filter, Paginator and ReactTable components.
   */
  render() {
    const {
      data,
      loading,
      fullLoading,
      onChangeNumberOfRows,
      onChangePage,
      numberOfRowsSelected,
      paginationDirection,
      onFilterById,
      classes,
      t,
    } = this.props;

    const { search } = this.state;
    const edges = loading ? [] : data.expiredAds.edges;
    const rows = this.renderRows(edges);
    const cols = this.renderColumns();

    return (
      <React.Fragment>
        <GridContainer justify="space-between" alignItems="center">
          <GridItem>
            <h3 className={classes.title}>{t('expired_ad.list.title')}</h3>
          </GridItem>
          <GridItem>
            <Button
              color="primary"
              simple
              onClick={this.handleRefresh}
              id="refresh"
              key="refresh"
            >
              <Refresh />
              {t('ad.filters.update')}
            </Button>
          </GridItem>
        </GridContainer>

        <div className={classes.contentContainer}>
          <div
            className={[classes.loadingLineContainer, classes.topLine].join(
              ' ',
            )}
          >
            {fullLoading && (
              <LinearProgress
                classes={{
                  barColorPrimary: classes.loadingLine,
                }}
              />
            )}
          </div>
          <GridContainer justify="space-between">
            <GridItem xs={12} sm={8} md={6} lg={4}>
              <CustomInput
                id="search"
                formControlProps={{
                  className: `${classes.top} ${classes.search}`,
                }}
                inputProps={{
                  placeholder: t('ad.filters.body.id_placeholder'),
                  inputProps: {
                    'aria-label': 'Search',
                    className: classes.searchInput,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <Button
                        justIcon
                        round
                        simple
                        onClick={() => {
                          onFilterById(search);
                        }}
                        color="primary"
                        id="search-submit"
                      >
                        <Search />
                      </Button>
                    </InputAdornment>
                  ),
                  onChange: e => {
                    const { value } = e.target;
                    this.setState({ search: value });
                  },
                  onKeyPress: e => {
                    if (e.key === 'Enter') {
                      onFilterById(search);
                    }
                  },
                  type: 'number',
                  value: search || '',
                }}
              />
            </GridItem>
            <GridItem xs={12} sm={8} md={6} lg={4}>
              {!fullLoading && data ? (
                <Paginator
                  pageInfo={data.expiredAds.pageInfo}
                  changePage={onChangePage}
                  changeNumberOfRows={onChangeNumberOfRows}
                  paginationDirection={paginationDirection}
                  numberOfRowsSelected={numberOfRowsSelected}
                />
              ) : (
                <ContentLoader height={67} width={327} speed={2}>
                  <path
                    // eslint-disable-next-line max-len
                    d="M199,16 L304,16 C307.313708,16 310,18.6862915 310,22 L310,46 C310,49.3137085 307.313708,52 304,52 L199,52 C195.686292,52 193,49.3137085 193,46 L193,22 C193,18.6862915 195.686292,16 199,16 Z M25.9861352,27.0121317 L70.0138648,27.0121317 C74.4244855,27.0121317 78,30.5876462 78,34.9982669 C78,39.4088876 74.4244855,42.9844021 70.0138648,42.9844021 L25.9861352,42.9844021 C21.5755145,42.9844021 18,39.4088876 18,34.9982669 C18,30.5876462 21.5755145,27.0121317 25.9861352,27.0121317 Z M103.986135,27.0121317 L148.013865,27.0121317 C152.424485,27.0121317 156,30.5876462 156,34.9982669 C156,39.4088876 152.424485,42.9844021 148.013865,42.9844021 L103.986135,42.9844021 C99.5755145,42.9844021 96,39.4088876 96,34.9982669 C96,30.5876462 99.5755145,27.0121317 103.986135,27.0121317 Z"
                    fill="#D8D8D8"
                  />
                </ContentLoader>
              )}
            </GridItem>
            <GridItem xs={12} className={classes.z3}>
              <div>
                {loading ? (
                  <TableLoader />
                ) : (
                  <ReactTable
                    data={rows}
                    filterable
                    columns={cols}
                    loading={loading}
                    pageSize={
                      edges.length < numberOfRowsSelected
                        ? edges.length
                        : numberOfRowsSelected
                    }
                    showPagination={false}
                    className={['-striped -highlight', classes.tbl].join(' ')}
                    defaultFilterMethod={(field, row) => {
                      const id = field.pivotId || field.id;
                      return row[id] !== undefined
                        ? String(row[id]).startsWith(field.value)
                        : true;
                    }}
                    SubComponent={() => (
                      <div className={classes.loading}>
                        <LoadingAnimation />
                      </div>
                    )}
                    noDataText={t('common.no_data')}
                    minRows={8}
                  />
                )}
              </div>

              <GridContainer justify="flex-end" alignItems="center">
                <GridItem xs={12} sm={8} md={6} lg={4}>
                  {!fullLoading && data ? (
                    <Paginator
                      pageInfo={data.expiredAds.pageInfo}
                      changePage={onChangePage}
                      changeNumberOfRows={onChangeNumberOfRows}
                      paginationDirection={paginationDirection}
                      numberOfRowsSelected={numberOfRowsSelected}
                    />
                  ) : (
                    <ContentLoader height={67} width={327} speed={2}>
                      <path
                        // eslint-disable-next-line max-len
                        d="M199,16 L304,16 C307.313708,16 310,18.6862915 310,22 L310,46 C310,49.3137085 307.313708,52 304,52 L199,52 C195.686292,52 193,49.3137085 193,46 L193,22 C193,18.6862915 195.686292,16 199,16 Z M25.9861352,27.0121317 L70.0138648,27.0121317 C74.4244855,27.0121317 78,30.5876462 78,34.9982669 C78,39.4088876 74.4244855,42.9844021 70.0138648,42.9844021 L25.9861352,42.9844021 C21.5755145,42.9844021 18,39.4088876 18,34.9982669 C18,30.5876462 21.5755145,27.0121317 25.9861352,27.0121317 Z M103.986135,27.0121317 L148.013865,27.0121317 C152.424485,27.0121317 156,30.5876462 156,34.9982669 C156,39.4088876 152.424485,42.9844021 148.013865,42.9844021 L103.986135,42.9844021 C99.5755145,42.9844021 96,39.4088876 96,34.9982669 C96,30.5876462 99.5755145,27.0121317 103.986135,27.0121317 Z"
                        id="Combined-Shape"
                        fill="#D8D8D8"
                      />
                    </ContentLoader>
                  )}
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </div>
      </React.Fragment>
    );
  }
}

/**
 * ExpiredAdList PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop ads query's results
 * @param numberOfRowsSelected - prop current number of rows selected
 * @param loading - prop ads query or mutations status
 * @param t - prop from HOC with string translations
 * @param adId - Ad id
 * @callback onChangePage - prop pass to Paginator
 * @callback onChangeNumberOfRows - prop pass to Paginator
 * @callback onFilterById - prop pass to Filter by id
 * @callback onRefresh - callback to refresh page
 */

ExpiredAdList.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.shape({}).isRequired,
  numberOfRowsSelected: PropTypes.number.isRequired,
  // eslint-disable-next-line react/require-default-props
  paginationDirection: PropTypes.string,
  onChangePage: PropTypes.func.isRequired,
  onChangeNumberOfRows: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fullLoading: PropTypes.bool.isRequired,
  adId: PropTypes.string,
  onFilterById: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
};

ExpiredAdList.defaultProps = {
  adId: '',
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const ExpiredAdWrapper = props => <ExpiredAdList {...props} />;

export default withTranslation()(
  withStyles(extendedTablesStyle)(ExpiredAdWrapper),
);
